import React from 'react'

// theme
import theme from '../../constants/aampeTheme'

import TextWrapper from '../display/layout/textWrapper'
// components
import TitledSection from '../display/layout/titledSection'

export default function FormulaError() {
    return (
        <div>
            <TitledSection title="We're having trouble rendering this message.">
                <TextWrapper>
                    The team is notified and someone will reach out to you soon
                    with a fix.
                </TextWrapper>
                <TextWrapper style={{ marginTop: theme.spacing4(4) }}>
                    Thanks for helping us beta test. We&#39;ll get these bugs
                    taken care of quick.
                </TextWrapper>
            </TitledSection>
        </div>
    )
}
